import React, { useState } from 'react';

import { Typography, Flex, Space } from 'antd';

import { ShipmentCard } from './ShipmentCard';
import { Shipment } from '../api/getShipment';
import { useInspectionTicketView } from '../hooks/useInspectionTicketView';
import SearchEmptyIcon from '@/components/icons/SearchEmptyIcon';

const { Text } = Typography;

export const Result = ({
  shipments = [],
  updateStep,
  setSelectedShipment,
}: {
  shipments: any[];
  updateStep: (step: number) => void;
  setSelectedShipment?: (shipment: Shipment) => void;
}) => {
  const { startInspection } = useInspectionTicketView();
  const [expandedCardIndex, setExpandedCardIndex] = useState<number | null>(
    null
  );

  const handleStartInspection = (shipment) => {
    const currentShipment = shipments.find((s) => s.lp_ui === shipment.lp_ui);

    if (currentShipment && setSelectedShipment) {
      setSelectedShipment(currentShipment);
      startInspection({
        currentTicketId: shipment?.current_ticket_id || '',
        lpUi: shipment.lp_ui,
        inspectionInProgress: shipment?.inspection_in_progress,
        shipmentId: shipment?.shipment_id,
        currentTicketStartDate: shipment?.current_ticket_start_date || '',
      });
    }
    updateStep(1);
  };

  if (shipments.length === 0) {
    return (
      <Space direction="vertical" align="center" style={{ paddingBottom: 16 }}>
        <SearchEmptyIcon />
        <Text
          style={{
            fontSize: '1rem',
            fontWeight: 500,
            lineHeight: '125%',
            color: '#595959',
          }}
        >
          Shipment not found
        </Text>
        <Text
          style={{
            fontSize: '1rem',
            fontWeight: 400,
            lineHeight: '135%',
            color: '#595959',
            textAlign: 'center',
            display: 'inline-block',
          }}
        >
          No matches were found for your search. Please check your input.
        </Text>
      </Space>
    );
  }

  return (
    <>
      <Flex justify="space-between" style={{ paddingBottom: 16 }}>
        <Text style={{ fontSize: '1rem', fontWeight: 500, lineHeight: '125%' }}>
          RESULTS
        </Text>
        <Text
          style={{ fontSize: '0.875rem', fontWeight: 400, lineHeight: '125%' }}
        >
          {shipments.length} BOXs found
        </Text>
      </Flex>
      <Text
        style={{
          fontSize: '1rem',
          fontWeight: 400,
          lineHeight: '135%',
          marginBottom: '0.75rem',
          display: 'inline-block',
        }}
      >
        Click for check the BOX
      </Text>
      {shipments.map((shipment, index) => (
        <ShipmentCard
          key={`card-${index}-${shipment.lp_ui}`}
          shipment={shipment}
          onStartInspection={handleStartInspection}
          isCollapse
          isExpanded={expandedCardIndex === index}
          onToggle={() =>
            setExpandedCardIndex(expandedCardIndex === index ? null : index)
          }
          isDisabled={expandedCardIndex !== null && expandedCardIndex !== index}
        />
      ))}
    </>
  );
};
